import React from "react";

function Mission() {
  return (
    <>
      <div className="d-flex flex-row gap-0 mx-4">
        <div className="card shadow ">
          <div className="card-header">
            <h6 className="text-violet text-start">Vision & Mission</h6>
          </div>
          <div className="card-body">
            <div className="gap-5 pb-5">
              <h6>Vision</h6>
              <p>
                We want to be the best Cargo Handling Terminal in the
                international arena while holding true to our Omani identity.
              </p>

              <h6>Our Mission</h6>
              <p>
                We work to be the best by benchmarking our services against the
                best in the industry.
              </p>
              <p>
                We are committed to constant upgrading of skills, processes and
                technology to operate more effectively in the given operating
                environment without compromising on quality and profitability.
              </p>
              <br></br>
              <h6>Our Core Values</h6>
              <ul>
                <li>Customer Focus</li>
                <li>Excellence and Innovation</li>
                <li>Integrity, Respect and Accountability</li>
                <li>People and Collaboration</li>
                <li>Safety and Security</li>
              </ul>
              <br></br>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Mission;
